(function() {
  'use strict';

  /* =============================================
     Config — read from section data attributes
     ============================================= */
  var KLAVIYO_KEY = '';
  var EMAIL_LIST_ID = '';
  var SMS_LIST_ID = '';

  function getConfig() {
    var el = document.querySelector('[data-klaviyo-public-key]');
    if (el) {
      KLAVIYO_KEY = el.getAttribute('data-klaviyo-public-key') || '';
      EMAIL_LIST_ID = el.getAttribute('data-klaviyo-email-list') || '';
      SMS_LIST_ID = el.getAttribute('data-klaviyo-sms-list') || '';
    }
  }

  /* =============================================
     Add to Cart
     ============================================= */
  /**
   * The cart element the theme renders — `cart-notification` or `cart-drawer`.
   * Both expose getSectionsToRender()/renderContents(), so the same code path
   * works for either cart type (see product-form.js).
   */
  function getCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function resetButton(button, btnText, spinner) {
    button.classList.remove('is-loading', 'is-added');
    button.disabled = false;
    if (btnText) btnText.textContent = 'Add to cart';
    if (spinner) spinner.classList.add('hidden');
  }

  function handleAddToCart(button) {
    if (button.disabled || button.classList.contains('is-loading')) return;

    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    var btnText = button.querySelector('.variant-card__btn-text');
    var spinner = button.querySelector('.loading__spinner');
    var cart = getCartElement();

    button.classList.add('is-loading');
    button.disabled = true;
    if (btnText) btnText.textContent = 'Adding...';
    if (spinner) spinner.classList.remove('hidden');

    var payload = { id: variantId, quantity: 1 };

    // Ask Shopify to render the cart sections in the same request so the drawer
    // can be repainted from the response instead of a second round trip.
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function(section) {
        return section.id;
      }).join(',');
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
    .then(function(response) { return response.json(); })
    .then(function(response) {
      if (response.status) {
        throw new Error(response.description || response.message || 'Failed to add to cart');
      }

      button.classList.remove('is-loading');
      button.classList.add('is-added');
      if (btnText) btnText.textContent = 'Added!';
      if (spinner) spinner.classList.add('hidden');

      // constants.js declares PUB_SUB_EVENTS with `const`, so it is not on `window`.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'variant-card',
          productVariantId: String(variantId),
          cartData: response
        });
      }

      if (cart && response.sections && typeof cart.renderContents === 'function') {
        cart.classList.remove('is-empty');
        // Repaints #CartDrawer + #cart-icon-bubble and opens the drawer.
        cart.renderContents(response);
      } else {
        // cart_type == 'page', or sections missing — keep the icon in sync at least.
        refreshCartBubble();
      }

      setTimeout(function() {
        resetButton(button, btnText, spinner);
      }, 2000);
    })
    .catch(function(error) {
      console.error('Add to cart error:', error);
      button.classList.remove('is-loading');
      button.disabled = false;
      if (spinner) spinner.classList.add('hidden');
      if (btnText) btnText.textContent = 'Error - Retry';

      setTimeout(function() {
        resetButton(button, btnText, spinner);
      }, 3000);
    });
  }

  /**
   * Fallback for themes without a drawer/notification: re-render the header cart
   * icon section so the bubble appears/disappears correctly (it is absent from
   * the DOM entirely while the cart is empty).
   */
  function refreshCartBubble() {
    var iconTarget = document.getElementById('cart-icon-bubble');
    if (!iconTarget) return;

    fetch('/?sections=cart-icon-bubble')
      .then(function(response) { return response.json(); })
      .then(function(sections) {
        var html = sections['cart-icon-bubble'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newContent = doc.querySelector('.shopify-section') || doc.body;
        iconTarget.innerHTML = newContent.innerHTML;
      })
      .catch(function(error) {
        console.error('Error refreshing cart bubble:', error);
      });
  }

  /* =============================================
     Notify Me Modal — Klaviyo BIS via API
     ============================================= */

  var modal = null;
  var currentVariantId = null;
  var REVISION = '2025-07-15';

  function openBISModal(button) {
    getConfig();
    modal = document.getElementById('bis-modal');
    if (!modal) return;

    currentVariantId = button.getAttribute('data-variant-id');

    // Reset to email step
    showStep('email');
    clearMessages();

    // Reset inputs
    var emailInput = modal.querySelector('#bis-email');
    var phoneInput = modal.querySelector('#bis-phone');
    var marketingCheckbox = modal.querySelector('#bis-marketing');
    var submitBtns = modal.querySelectorAll('.bis-modal__submit');

    if (emailInput) emailInput.value = '';
    if (phoneInput) phoneInput.value = '';
    if (marketingCheckbox) marketingCheckbox.checked = false;
    submitBtns.forEach(function(btn) {
      btn.disabled = false;
      btn.textContent = 'Notify Me';
    });

    // Open
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    if (emailInput) {
      setTimeout(function() { emailInput.focus(); }, 150);
    }
  }

  function closeBISModal() {
    if (!modal) modal = document.getElementById('bis-modal');
    if (modal) {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      currentVariantId = null;
    }
  }

  function showStep(step) {
    if (!modal) return;
    modal.querySelectorAll('.bis-modal__step').forEach(function(el) {
      el.classList.remove('is-active');
    });
    var target = modal.querySelector('[data-step="' + step + '"]');
    if (target) target.classList.add('is-active');
  }

  function clearMessages() {
    if (!modal) return;
    modal.querySelectorAll('.bis-modal__message').forEach(function(el) {
      el.className = 'bis-modal__message';
      el.style.display = 'none';
      el.textContent = '';
    });
  }

  function showMessage(type, text) {
    if (!modal) return;
    var activeStep = modal.querySelector('.bis-modal__step.is-active');
    if (!activeStep) return;
    var msgEl = activeStep.querySelector('.bis-modal__message');
    if (msgEl) {
      msgEl.textContent = text;
      msgEl.className = 'bis-modal__message ' + (type === 'success' ? 'is-success' : 'is-error');
      msgEl.style.display = 'block';
    }
  }

  /* --- API calls --- */

  function klaviyoFetch(endpoint, payload) {
    return fetch(
      'https://a.klaviyo.com/client/' + endpoint + '/?company_id=' + encodeURIComponent(KLAVIYO_KEY),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': REVISION
        },
        body: JSON.stringify(payload)
      }
    ).then(function(response) {
      if (!response.ok && response.status !== 202) {
        throw new Error('Klaviyo API error: ' + response.status);
      }
      return response;
    });
  }

  function subscribeBISEmail(email) {
    return klaviyoFetch('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + currentVariantId
            }
          }
        }
      }
    });
  }

  function subscribeMarketing(email) {
    if (!EMAIL_LIST_ID) return Promise.resolve();
    return klaviyoFetch('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: {
                  email: {
                    marketing: { consent: 'SUBSCRIBED' }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: EMAIL_LIST_ID }
          }
        }
      }
    });
  }

  function subscribeSMSConsent(phone) {
    if (!SMS_LIST_ID) return Promise.resolve();
    return klaviyoFetch('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                phone_number: phone,
                subscriptions: {
                  sms: {
                    marketing: { consent: 'SUBSCRIBED' }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: SMS_LIST_ID }
          }
        }
      }
    });
  }

  function subscribeBISSMS(phone) {
    return klaviyoFetch('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['SMS'],
          profile: {
            data: {
              type: 'profile',
              attributes: { phone_number: phone }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + currentVariantId
            }
          }
        }
      }
    });
  }

  /* --- Form handlers --- */

  function handleEmailSubmit(e) {
    e.preventDefault();
    if (!KLAVIYO_KEY || !currentVariantId) return;

    var emailInput = modal.querySelector('#bis-email');
    var marketingCheckbox = modal.querySelector('#bis-marketing');
    var submitBtn = e.target.querySelector('.bis-modal__submit');
    var email = emailInput ? emailInput.value.trim() : '';

    if (!email) return;

    clearMessages();
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
    }

    // 1. BIS email subscription
    var promises = [subscribeBISEmail(email)];

    // 2. Marketing opt-in if checked
    if (marketingCheckbox && marketingCheckbox.checked) {
      promises.push(subscribeMarketing(email));
    }

    Promise.all(promises)
    .then(function() {
      showMessage('success', "You're on the list! We'll email you when this item is back in stock.");
      if (e.target) e.target.style.display = 'none';
    })
    .catch(function(err) {
      console.error('BIS email error:', err);
      showMessage('error', 'Something went wrong. Please try again.');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Notify Me';
      }
    });
  }

  function handleSMSSubmit(e) {
    e.preventDefault();
    if (!KLAVIYO_KEY || !currentVariantId) return;

    var countryCode = modal.querySelector('#bis-country-code');
    var phoneInput = modal.querySelector('#bis-phone');
    var submitBtn = e.target.querySelector('.bis-modal__submit');

    var code = countryCode ? countryCode.value : '+1';
    var number = phoneInput ? phoneInput.value.trim().replace(/[^0-9]/g, '') : '';

    if (!number) return;

    var fullPhone = code + number;

    clearMessages();
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
    }

    // 1. SMS consent first (required), then 2. BIS SMS subscription
    subscribeSMSConsent(fullPhone)
    .then(function() {
      return subscribeBISSMS(fullPhone);
    })
    .then(function() {
      showMessage('success', "You're on the list! We'll text you when this item is back in stock.");
      if (e.target) e.target.style.display = 'none';
    })
    .catch(function(err) {
      console.error('BIS SMS error:', err);
      showMessage('error', 'Something went wrong. Please try again.');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Notify Me';
      }
    });
  }

  /* =============================================
     Event Delegation
     ============================================= */

  document.addEventListener('click', function(e) {
    // Add to Cart
    var atcBtn = e.target.closest('.variant-card__add-to-cart');
    if (atcBtn) {
      e.preventDefault();
      handleAddToCart(atcBtn);
      return;
    }

    // Notify Me — open BIS modal
    var notifyBtn = e.target.closest('.variant-card__notify-me');
    if (notifyBtn) {
      e.preventDefault();
      openBISModal(notifyBtn);
      return;
    }

    // Close modal
    if (e.target.closest('.bis-modal__close') || e.target.classList.contains('bis-modal__overlay')) {
      closeBISModal();
      return;
    }

    // Toggle to SMS step
    if (e.target.closest('[data-bis-toggle="sms"]')) {
      e.preventDefault();
      clearMessages();
      showStep('sms');
      var phoneInput = modal.querySelector('#bis-phone');
      if (phoneInput) setTimeout(function() { phoneInput.focus(); }, 100);
      return;
    }

    // Toggle to Email step
    if (e.target.closest('[data-bis-toggle="email"]')) {
      e.preventDefault();
      clearMessages();
      showStep('email');
      var emailInput = modal.querySelector('#bis-email');
      if (emailInput) setTimeout(function() { emailInput.focus(); }, 100);
      return;
    }
  });

  // Form submissions
  document.addEventListener('submit', function(e) {
    if (e.target.closest('#bis-email-form')) {
      handleEmailSubmit(e);
    }
    if (e.target.closest('#bis-sms-form')) {
      handleSMSSubmit(e);
    }
  });

  // ESC to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeBISModal();
  });

})();
